import { z } from "zod";
import { languagesEnum, UnableToNormalizeData } from "../../../types-schemas";

// NOT USED ANYMORE
export const sUOnHTTPRequestDataSchema = z.object({
  name: z.string(),
  email: z.string(),
  password: z.string(),
  phoneNumber: z.string(),
  phoneNumber_countryCode: z.string(),
  language: languagesEnum,
});

export type SUOnHTTPRequestData = z.infer<typeof sUOnHTTPRequestDataSchema>;

export const normalizeSUOnHTTPRequestData = (
  data: any
): SUOnHTTPRequestData => {
  try {
    return sUOnHTTPRequestDataSchema.parse(data);
  } catch (error: any) {
    throw new UnableToNormalizeData({ error: error, data: data });
  }
};

export const sUOnHTTPRequestResponseSchema = z.object({
  uid: z.string(),
});

export type SUOnHTTPRequestResponse = z.infer<
  typeof sUOnHTTPRequestResponseSchema
>;

export const normalizeSUOnHTTPRequestResponse = (
  data: any
): SUOnHTTPRequestResponse => {
  try {
    return sUOnHTTPRequestResponseSchema.parse(data);
  } catch (error: any) {
    throw new UnableToNormalizeData({ error: error, data: data });
  }
};
